var map = {
	"./banya-01.jpg": 13847,
	"./banya-02.jpg": 59511,
	"./banya-03.jpg": 83901,
	"./banya-04.jpg": 62736,
	"./banya-05.jpg": 80243,
	"./banya-06.jpg": 78475,
	"./banya-07.jpg": 19866,
	"./banya-08.jpg": 5561,
	"./banya-09.jpg": 74865,
	"./banya-10.jpg": 64478,
	"./banya-11.jpg": 48616,
	"./banya-12.jpg": 9822,
	"./banya-13.jpg": 62910,
	"./banya-14.jpg": 20016,
	"./banya-15.jpg": 53412,
	"./banya-16.jpg": 64329,
	"./banya-17.jpg": 18964,
	"./banya-18.jpg": 16437,
	"./banya-19.jpg": 4751,
	"./banya-20.jpg": 97386,
	"./banya-21.jpg": 62644,
	"./banya-22.jpg": 76985,
	"./banya-23.jpg": 68028,
	"./banya-24.jpg": 91421,
	"./banya-25.jpg": 65114,
	"./banya-26.jpg": 36756,
	"./banya-27.jpg": 38768,
	"./banya-28.jpg": 32399,
	"./banya-29.jpg": 10513,
	"./banya-30.jpg": 35599,
	"./banya-31.jpg": 91831,
	"./banya-32.jpg": 78041,
	"./banya-33.jpg": 6729,
	"./banya-34.jpg": 56489,
	"./banya-35.jpg": 6762,
	"./banya-36.jpg": 25433,
	"./banya-37.jpg": 51773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85853;